import React, {Component} from 'react';
import { fileUrl } from '../../../../../../util/file_url'
export default class VideoPlayer extends Component {

    render() {
        return (
            <div id="attachment-form-preview" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                overflow: 'hidden'
            }}>
                <video 
                    preload="metadata"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                    }}
                    src={fileUrl(this.props.filename)} 
                    controls 
                />
            </div>
        );
    }
};